var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "HeaderTime",
    class: {
      'WorkBenchTime': _vm.judgeWorkbench
    }
  }, [_c('div', {
    attrs: {
      "id": "clock-container"
    }
  }, [_vm._l(6, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "display-container",
      class: [`display-container${index}`, `display-no-${_vm.TimeClass[index]}`]
    }, [_c('div', {
      staticClass: "segment-b segment-1"
    }), _c('div', {
      staticClass: "segment-l segment-2"
    }), _c('div', {
      staticClass: "segment-l segment-3"
    }), _c('div', {
      staticClass: "segment-t segment-4"
    }), _c('div', {
      staticClass: "segment-r segment-5"
    }), _c('div', {
      staticClass: "segment-r segment-6"
    }), _vm._m(0, true)]);
  }), _c('div', {
    staticClass: "colon"
  }), _c('div', {
    staticClass: "colon colon1"
  })], 2), _c('div', {
    staticClass: "FormatTimeZone"
  }, [_vm._v(" " + _vm._s(this.Format) + " " + _vm._s(this.timeZone) + " ")])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "segment-h segment-7"
  }, [_c('span', {
    staticClass: "segment-border"
  })]);
}];
export { render, staticRenderFns };